import { z } from '@harvestiq/zod';

export const sendLrpCampaignEmailsMessageSchema = z.object({
  campaignId: z.string(),
  orgId: z.string(),
  salesEffectiveDate: z.string().optional(), // This should be used only for manual queuing scripts. Do not actively use it.
});

export type SendLrpCampaignEmailsMessage = z.infer<
  typeof sendLrpCampaignEmailsMessageSchema
>;
